import React, { Component } from 'react';
import kpitLogo from './../../images/kpit_logo_new.png'
import simulibIcon from './../../images/simulib_icon.png';
import automateKPIIcon from './../../images/automate_kpi_icon.png';
import sceneGenIcon from './../../images/scene_gen_icon.png';
import SimulibNavbar from './SimulibNavbar'
import PropTypes from 'prop-types';

class AboutComponent extends Component {
    constructor(props){
        super(props)
        this.logOut = this.logOut.bind(this);
    }

    logOut() {
        localStorage.removeItem('usertoken');
        this.props.history.push('/')
    }

    render(){
    return(
    <div data-test='aboutComponent' id="purple-background">
        <SimulibNavbar logOut={this.logOut}/>
        <div className='container-fluid'>
            <div className='row' style={{paddingTop: "3%"}}>
                <div className='col-md-8'>
                    <div className='card'>
                        <div className='card-body' style={{height: "100%"}}>
                            <div>
                                <div className="SimuLib-logo">
                                    <img src={simulibIcon} alt=""
                                         style={{paddingLeft: "75%", paddingTop: "5%", width: "94%"}} />
                                </div>
                                <h2 style={{fontSize: "16px", paddingLeft: "5%", fontWeight: "bold"}}>About SimuLib.AD</h2>
                                <div className='row' style={{paddingTop: "3%"}}>
                                    <div className='col-md-6'>
                                        <p style={{paddingLeft: "10%", fontSize: "16px"}}>SimuLib.AD is a library of scenarios KPIT
                                            has built to support the development of Autonomous Driving solutions. Customers /
                                            developers can choose these ready scenarios best suited for the function or feature
                                            they want to validate. The library has scenarios that cover all features and
                                            function prescribed by industry standards like ISO , NCAP , SAE , NHTSA etc.
                                            Developers can also choose scenarios by geography (EU, US etc.) by application
                                            (Highway, Urban, Auto parking etc. ) and they will also be able to test logical
                                            components like perception, situation assessment, motion control, decision and
                                            planning. There is special focus on scenarios for Functional Safety and Safety of
                                            the Intended Functions (SOTiF) that are critical for the development of Dependable
                                            AD software.</p>
                                    </div>
                                    <div className='col-md-6'>
                                        <div>
                                            <p style={{paddingLeft: "10%", paddingRight: "5%", fontSize: "16px"}}>The library is
                                                developed
                                                on a unique Functional Validation Strategy, where each segment/element required
                                                for
                                                scenario creation is listed in a tree-based structure and combination of these
                                                elements helps create a large number of scenario combination required for
                                                validation
                                                coverage</p>
                                            <p style={{paddingLeft: "10%", fontSize: "16px"}}>
                                                Whilst executing virtual simulation, SimuLib.AD helps you answer...</p>
                                            <ul style={{paddingLeft: "10%", fontSize: "16px"}}>
                                                <li>
                                                    How to achieve maximum coverage?
                                                </li>
                                                <li>
                                                    Are all scenario combination valid and realistic?
                                                </li>
                                                <li>
                                                    How close are these scenarios to real world driving conditions?
                                                </li>
                                                <li>
                                                    How can we achieve millions of miles through scenario-based approach?
                                                </li>
                                                <li>
                                                    Are these scenarios covering all corner/critical cases?
                                                </li>
                                                <li>
                                                    How can we use scenario-based validation in SOTIF(to identify Unknowns)?
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3" style={{paddingLeft: "5%"}}>
                                        <p style={{fontWeight: "bold"}}>Our Other tools</p>
                                    </div>
                                    <div className="col-md-9">
                                        <hr/>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <img style={{width: "50%", paddingLeft: "10%"}}
                                                     src={automateKPIIcon} alt=""/>
                                            </div>
                                        </div>
                                        <p style={{paddingTop: "2%", paddingLeft: "10%", fontSize: "16px"}}>AutomateKPI.AD is a smart
                                            database of all applicable KPI’s well defined and generated exhaustively across
                                            features and functions. A smart framework which enables selection of respective and
                                            applicable KPI’s during feature or function under test. Its not limited to function
                                            or feature but has KPI databases for sensors, components and systems as well.</p>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <img style={{width: "36%", paddingLeft: "10%"}}
                                                     src={sceneGenIcon} alt="" />
                                            </div>
                                        </div>
                                        <p style={{paddingTop: "2%" ,paddingLeft: "10%", paddingRight: "5%", fontSize: "16px"}}>
                                            ScenGen.AD is a unique framework which using strategy will automatically generate
                                            valid scenario combinations and generate model in open standards ready to be
                                            integrated with various simulators. The generated scenarios will not be limited to
                                            functions/features but will also have scenarios to test safety, security as well as
                                            safety of intended functionality(SOTiF).</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className="card" style={{height: "100%"}}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <img src={kpitLogo} alt=""
                                         style={{paddingLeft: "50%", paddingTop: "5%"}} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 style={{paddingTop: "28%", paddingLeft: "5%", fontSize: "16px", color: "#622AD8"}}>About
                                        KPIT</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <p style={{paddingTop: "17%", paddingLeft: "6%", paddingRight: "10%", paddingBottom: "38%", fontSize: "16px"}}>
                                        KPIT is a global technology company with software solutions that will help mobility
                                        leapfrog towards autonomous, clean, smart and connected future. With 6000+
                                        Automobelievers across the globe, specializing in embedded software, AI & Digital
                                        solutions, KPIT enables customers accelerate implementation of next generation
                                        mobility technologies . With development centers in Europe, USA, Japan, China,
                                        Thailand and India – KPIT works with leaders in mobility and is present where the
                                        ecosystem is transforming. For more details visit www.KPIT.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)
}
}
AboutComponent.propTypes={
history:PropTypes.string,
}
AboutComponent.defaultProps= {
history:[],
}
// class AboutComponent extends Component {
//     constructor(props){
//         super(props)
//         this.logOut = this.logOut.bind(this);
//     }

//     logOut() {
//         localStorage.removeItem('usertoken');
//         this.props.history.push('/')
//     }

//     class AboutComponent extends Component {
//         constructor(props){
//             super(props)
//             this.logOut = this.logOut.bind(this);
//         }

//         logOut() {
//             localStorage.removeItem('usertoken');
//             this.props.history.push('/')
//         }

//         class AboutComponent extends Component {
//             constructor(props){
//                 super(props)
//                 this.logOut = this.logOut.bind(this);
//             }

//             logOut() {
//                 localStorage.removeItem('usertoken');
//                 this.props.history.push('/')
//             }

//             class AboutComponent extends Component {
//                 constructor(props){
//                     super(props)
//                     this.logOut = this.logOut.bind(this);
//                 }

//                 logOut() {
//                     localStorage.removeItem('usertoken');
//                     this.props.history.push('/')
//                 }

//                 class AboutComponent extends Component {
//                     constructor(props){
//                         super(props)
//                         this.logOut = this.logOut.bind(this);
//                     }

//                     logOut() {
//                         localStorage.removeItem('usertoken');
//                         this.props.history.push('/')
//                     }
export default AboutComponent;
